export const GRAPH_HEIGHT = 185;

export const MONTH_NAMES = [
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];

export const DAYS = 'days';
export const WEEKS = 'weeks';
export const MONTHS = 'months';



// WEBPACK FOOTER //
// ./components/accuracy-overview-graph/accuracy-overview.constants.js